import { defineMessages } from 'react-intl';

export default defineMessages({
  weixinBrowserError: {
    id: 'errorMessages.weixinBrowserError',
    defaultMessage: '请在微信、微信小程序或者支付宝浏览器中打开',
  },
  noTableError: {
    id: 'errorMessages.noTableError',
    defaultMessage: '非常抱歉，店里当前爆满，无可用桌台',
  },
  noTableUseError: {
    id: 'errorMessages.noTableUseError',
    defaultMessage: '没有可用桌台',
  },
  cantScanPlaceOrderError: {
    id: 'errorMessages.cantScanPlaceOrderError',
    defaultMessage: '商户配置错误, 无法扫码下单',
  },
  identifyQRCodeError: {
    id: 'errorMessages.identifyQRCodeError',
    defaultMessage: '无法识别该二维码',
  },
  operateFailError: {
    id: 'errorMessages.operateFailError',
    defaultMessage: '操作失败',
  },
  alipayConfigFailError: {
    id: 'errorMessages.alipayConfigFailError',
    defaultMessage: '支付宝配置失败...',
  },
  getQRCodeFailError: {
    id: 'errorMessages.getQRCodeFailError',
    defaultMessage: '获取二维码失效',
  },
  scanResultEmptyError: {
    id: 'errorMessages.scanResultEmptyError',
    defaultMessage: '扫码结果为空',
  },
  choosePlaceOrderError: {
    id: 'errorMseeage.choosePlaceOrderError',
    defaultMessage: '请选择需要的下单操作...',
  },
  goingServiceCardError: {
    id: 'errorMessage.goingServiceCardError',
    defaultMessage: '正在跳转到服务卡界面...',
  },
  pleaseHaveDinnerError: {
    id: 'errorMessage.pleaseHaveDinnerError',
    defaultMessage: '请点餐',
  },
  netWorkError: {
    id: 'errorMessage.netWorkError',
    defaultMessage: '网络出问题了...',
  },
  intoTableError: {
    id: 'errorMessage.intoTableError',
    defaultMessage: '进入桌台...',
  },
  alreadyPlaceOrderError: {
    id: 'errorMessage.alreadyPlaceOrderError',
    defaultMessage: '{user}已经下单, 自动跳转中...',
  },
  socketLinkError: {
    id: 'errorMessage.socketLinkError',
    defaultMessage: '协同点餐异常，请刷新页面',
  },
  noConfigServiceBellError: {
    id: 'errorMessage.noConfigServiceBellError',
    defaultMessage: '还没有配置服务噢...',
  },
  noBindTableError: {
    id: 'errorMessage.noBindTableError',
    defaultMessage: '未绑定桌台哦，小二会迷路呢',
  },
  waiterIsComingError: {
    id: 'errorMessage.waiterIsComingError',
    defaultMessage: '小二正在火速赶来的路上...',
  },
  chooseServiceError: {
    id: 'errorMessage.chooseServiceError',
    defaultMessage: '请选择服务',
  },
  collCartError: {
    id: 'errorMessage.collCartError',
    defaultMessage: '协同购物车错误',
  },
  orderIsInvalided: {
    id: 'errorMessage.orderIsInvalided',
    defaultMessage: '订单已作废，请重新下单',
  },
  orderIsRefused: {
    id: 'errorMessage.orderIsRefused',
    defaultMessage: '订单已拒绝，请重新下单',
  },
  orderIsCanceled: {
    id: 'errorMessage.orderIsCanceled',
    defaultMessage: '订单已取消，请重新下单',
  },
  unopenedOnlinePayment: {
    id: 'errorMessage.unopenedOnlinePayment',
    defaultMessage: '未开通线上支付无法结账',
  },
  completeTheInvoice: {
    id: 'errorMessage.completeTheInvoice',
    defaultMessage: '请把发票填写完整',
  },
  youAreInvoicing: {
    id: 'errorMessage.youAreInvoicing',
    defaultMessage: '别着急,正在开票中',
  },
  tasteScore: {
    id: 'errorMessage.tasteScore',
    defaultMessage: '请评价口味！',
  },
  serviceScore: {
    id: 'errorMessage.serviceScore',
    defaultMessage: '请评价服务！',
  },
  environmentScore: {
    id: 'errorMessage.environmentScore',
    defaultMessage: '请评价环境！',
  },
  commentSuccess: {
    id: 'errorMessage.commentSuccess',
    defaultMessage: '订单评价成功',
  },
  commentSuccessButNoCoupon: {
    id: 'errorMessage.commentSuccessButNoCoupon',
    defaultMessage: '订单评价成功，优惠券已赠完',
  },
  commentSuccessAndGetCoupon: {
    id: 'errorMessage.commentSuccessAndGetCoupon',
    defaultMessage: '订单评价成功，恭喜获得{sendCoupInfo}',
  },
  orderIsCommented: {
    id: 'errorMessage.orderIsCommented',
    defaultMessage: '该订单已评价',
  },
  orderIsNotSupportCommented: {
    id: 'errorMessage.orderIsNotSupportCommented',
    defaultMessage: '当前订单不支持评价',
  },
  commentAgainForNetwork: {
    id: 'errorMessage.commentAgainForNetwork',
    defaultMessage: '网络原因评价失败，请重新评价',
  },
  notMobileStore: {
    id: 'errorMessage.notMobileStore',
    defaultMessage: '当前门店未开通移动门店，请联系商户',
  },
  connectingCollCart: {
    id: 'loading.connectingCollCart',
    defaultMessage: '正在连接协同购物车...',
  },
  connecting: {
    id: 'loading.connecting',
    defaultMessage: '正在连接...',
  },
  beingInTheVoucher: {
    id: 'loading.beingInTheVoucher',
    defaultMessage: '正在领券中...',
  },
  onlyStockLeft: {
    id: 'errorMessage.onlyStockLeft',
    defaultMessage: '抱歉，库存仅剩{numTotal}',
  },
  enteredUpTo5digits: {
    id: 'errorMessage.enteredUpTo5digits',
    defaultMessage: '最多可输入5位数',
  },
  notLowerThanDishIncreaseUnit: {
    id: 'errorMessage.notLowerThanDishIncreaseUnit',
    defaultMessage: '不能低于起卖份数{dishIncreaseUnit}份',
  },
  dishChangeRule: {
    id: 'errorMessage.dishChangeRule',
    defaultMessage:
      '该商品起卖份数为{dishIncreaseUnit},增量为{stepNum},故修改份数为{dishChange}',
  },
  successGetCoupon: {
    id: 'errorMessage.successGetCoupon',
    defaultMessage: '成功领取优惠券',
  },
  failedGetCoupon: {
    id: 'errorMessage.failedGetCoupon',
    defaultMessage: '领取失败请重试',
  },
  onlyForDigital: {
    id: 'errorMessage.onlyForDigital',
    defaultMessage: '只能输入数字',
  },
  maxSupportUserNum: {
    id: 'errorMessage.maxSupportUserNum',
    defaultMessage: '最多支持{maximum}人',
  },
  minInputUserNum: {
    id: 'errorMessage.minInputUserNum',
    defaultMessage: '至少输入{minimum}人',
  },
  unknown: {
    id: 'errorMessage.unknown',
    defaultMessage: '未知',
  },
  netError: {
    id: 'errorMessage.netError',
    defaultMessage: '网络出错',
  },
  waiterWillCome: {
    id: 'callMessage.waiterWillCome',
    defaultMessage: '客官稍等，服务员马上就来',
  },
  sendFail: {
    id: 'errorMessage.sendFail',
    defaultMessage: '非常抱歉，发送失败了',
  },
  requestAPIFail: {
    id: 'errorMessage.requestAPIFail',
    defaultMessage: '请求接口失败',
  },
  tryAgainForGet: {
    id: 'errorMessage.tryAgainForGet',
    defaultMessage: '非常抱歉，领取失败，请重试',
  },
  cantCallTableQRCode: {
    id: 'errorMessage.cantCallTableQRCode',
    defaultMessage: '不能调起桌台扫码',
  },
  clearedCart: {
    id: 'toast.clearedCart',
    defaultMessage: '已清空购物车',
  },
  submittedOrder: {
    id: 'toast.submittedOrder',
    defaultMessage: '已提交本桌订单',
  },
  entringOrderDetailPage: {
    id: 'toast.entringOrderDetailPage',
    defaultMessage: '正在进入订单详情页...',
  },
  modifyNumOnCartPage: {
    id: 'toast.modifyNumOnCartPage',
    defaultMessage: '{invalidDishList}的数量有误，请在购物车界面修改商品数量',
  },
  networkFailTryRefresh: {
    id: 'errorMessage.networkFailTryRefresh',
    defaultMessage: '当前网络环境差，请刷新后重试',
  },
  phoneValidateError: {
    id: 'errorMessage.phoneValidate',
    defaultMessage: '请输入正确的手机号',
  },
  disconnected: {
    id: 'errorMessage.disconnected',
    defaultMessage: '连接已断开',
  },
  errorAndReconnect: {
    id: 'errorMessage.errorAndReconnect',
    defaultMessage: '连接异常, 正在重新连接...',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/error-message/index.js